const currencies_list = [
    ['cad', 'C$'],
    ['usd', 'US$'],
    ['gbp', '£'],
    ['euro', '€'],
    ['mex', 'Mex$'],
]

export default currencies_list;